export default "<h1 class=\"no-wrap\">Hlavička objednávky</h1>\n<new-package-form [eshop]=\"eshop\"></new-package-form>"